<template>
  <div>
    <loading-component :isDashLoading="isDashLoading" />
    <el-tabs type="border-card" @tab-click="getDataAudit">
      <el-tab-pane :style="getStyle">
        <span slot="label">
          <em class="el-icon-tickets"></em>
          {{ $t('common_words.general_information2') }}
        </span>
        <p class="justify-paragraph fs-14 mt-2 mb-1">
          {{ $t('common_words.selected_record_info') }}
        </p>
        <slot name="info"></slot>
      </el-tab-pane>
      <el-tab-pane :label="$t('audit.audit')" v-if="isSuper() || isAdmin()">
        <span slot="label">
          <em class="el-icon-timer"></em> {{ $t('audit.audit') }}
        </span>
        <card-header
          :propPagination="pagination"
          @searchedQuery="searchedQuery"
          class="mr-3 mt-3"
        />
        <master-table
          :columns="tableProperties.tableColumns"
          :infoTable="queriedData"
          :defaultSort="tableProperties.defaultSort"
        >
          <template slot="appendColumns">
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="text-left">
                  <div class="row">
                    <div class="col-6">
                      <p>{{ $t('audit.log') }}</p>
                      <json-viewer
                        v-if="props.row.request_log"
                        :value="props.row.request_log"
                        :expand-depth="5"
                        copyable
                        boxed
                        sort
                      ></json-viewer>
                    </div>
                    <div class="col-6">
                      <p>{{ $t('audit.log_operation') }}</p>
                      <json-viewer
                        v-if="props.row.operation_log"
                        :value="props.row.operation_log"
                        :expand-depth="5"
                        copyable
                        boxed
                        sort
                      ></json-viewer>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </template>
        </master-table>
        <card-footer ref="cardfooter" :propPagination="pagination" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import AuditTable from './audit-table';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinTable from 'src/mixins/mixin-table';
import MixinAlert from 'src/mixins/mixin-alert';

export default {
  name: 'content-show-dialog',
  data() {
    return {
      tableProperties: {},
      isDashLoading: false,
    };
  },
  props: {
    registerId: {
      type: Number,
      default: 0,
    },
    model: {
      type: String,
      default: '',
    },
    fullHeight: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    '$i18n.locale': 'setupTable',
  },
  computed: {
    getStyle() {
      if (this.fullHeight)
        return 'min-height: calc(100vh - 11vh); overflow-y: auto';
      return '';
    },
    buildTableProperties() {
      return {
        tableColumns: [...AuditTable().tableColumns],
        defaultSort: { prop: 'updated_at', order: 'descending' },
      };
    },
  },
  mixins: [MixinPermissions, MixinTable, MixinAlert],
  methods: {
    setupTable() {
      this.tableProperties = {
        ...this.tableProperties,
        ...this.buildTableProperties,
      };
      this.setTableData();
    },
    getDataAudit(tab) {
      if (tab.index == 1) {
        this.isDashLoading = true;
        Axios.postMasters({
          route: 'model/audit',
          data: { audit: this.model, data: this.registerId },
        })
          .then((response) => {
            this.isDashLoading = false;
            this.tableProperties = {
              ...this.buildTableProperties,
              data: response.data.data,
            };
            this.setTableData();
          })
          .catch((error) => {
            this.showMessageErrors(error);
          });
      }
    },
    setTableData() {
      const { tableColumns, data } = this.tableProperties;
      this.tableData = data;
      this.searchFuse(
        tableColumns.map((column) => {
          return column.prop;
        })
      );
    },
  },
};
</script>
